












































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Item, OrdinarySchool, OtherTest } from '@/modules/itemSelect';
import { SchoolTypes, getSchoolTypeItems, getTestSchoolTypeItems } from '@/enums/schoolTypes';
import { getSchoolTermSemesterItems, getSchoolTermTestSemesterItems } from '@/enums/schoolTerms';
import {
  getGradeYearItems,
  getElementarySchoolGradeYearItems,
  getMiddleSchoolGradeYearItems,
  getHighSchoolGradeYearItems
} from '@/enums/gradeYears';
import { Calendar } from '@/modules/calendar';

@Component
export default class ItemSelect extends Vue {
  @Prop({ required: true }) private type: string;
  @Prop() private multiple!: boolean;
  @Prop() private clearable: boolean;
  @Prop() private typeObject: boolean;
  @Prop() private firstSelect: boolean;
  @Prop([Number, String, Object, Array])
  private selectedItem!: number | number[] | string | string[] | Item | Item[] | null;
  @Prop() private isAll!: boolean;
  @Prop({ default: null }) private allDisplayedText!: string | null;
  @Prop() private allowCreate: boolean;
  @Prop() private placeholder: string;
  @Prop() private size: string;
  @Prop() private optionSize: string;
  @Prop({ default: false }) private disabled: boolean;

  private items: Item[] = [];
  private selectedModel = !this.selectedItem ? this.multiple ? new Array<Item>()
                          : this.isAll ? 0 : null : this.selectedItem;

  public get Items(): Item[] {
    return this.items;
  }

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  @Watch('type')
  private onTypeChanged(val: string, before: string) {
    this.loadData();
    if (this.multiple) {
      this.selectedModel = new Array<Item>();
    } else {
      if (!this.firstSelect || this.items.length === 0) {
        this.selectedModel = null;
      } else {
        this.selectedModel = this.typeObject ? this.items[0] : this.items[0].id;
      }
    }
    this.onChangeSelect();
  }

  @Watch('selectedItem')
  private onSelectedItem(val: Item | Item[]) {
    this.selectedModel = val;
  }

  private mounted() {
    this.loadData();
  }

  private loadData() {
    switch (this.type) {
      case 'semester':
        this.setItems_semester();
        break;
      case 'regularTest':
        this.setItems_regularTest();
        break;
      case 'schoolType':
        this.setItems_schoolType();
        break;
      case 'test-schoolType':
        this.setItems_testSchoolType(false);
        break;
      case 'test-schoolType-regularTest':
        this.setItems_testSchoolType(true);
        break;
      case 'tag':
        this.setItems_tag();
        break;
      case 'teacher':
        this.setItems_teacher();
        break;
      case 'school':
        this.setItems_school(SchoolTypes.All);
        break;
      case 'school-pre':
        this.setItems_school(SchoolTypes.PreSchool);
        break;
      case 'school-elementary':
        this.setItems_school(SchoolTypes.ElementarySchool);
        break;
      case 'school-middle':
        this.setItems_school(SchoolTypes.MiddleSchool);
        break;
      case 'school-high':
        this.setItems_school(SchoolTypes.HighSchool);
        break;
      case 'grade':
        this.setItems_grade(SchoolTypes.All);
        break;
      case 'grade-elementary':
        this.setItems_grade(SchoolTypes.ElementarySchool);
        break;
      case 'grade-middle':
        this.setItems_grade(SchoolTypes.MiddleSchool);
        break;
      case 'grade-high':
        this.setItems_grade(SchoolTypes.HighSchool);
        break;
      case 'subject':
        this.setItems_subject();
        break;
      case 'simulation-test':
        this.setItems_simulationTest(SchoolTypes.All);
        break;
      case 'simulation-test-elementary':
        this.setItems_simulationTest(SchoolTypes.ElementarySchool);
        break;
      case 'simulation-test-middle':
        this.setItems_simulationTest(SchoolTypes.MiddleSchool);
        break;
      case 'simulation-test-high':
        this.setItems_simulationTest(SchoolTypes.HighSchool);
        break;
      case 'regist-calender':
        this.setItems_registCalenders();
        break;
      default:
        if (this.type.indexOf('simulation-test-times-') === 0) {
          const simulationTestId = this.type.slice('simulation-test-times-'.length);
          this.setItems_simulationTestTimes(simulationTestId);
        }
        break;
    }
  }

  // 学期
  private setItems_semester() {
    this.items = getSchoolTermSemesterItems(this.isAll);
  }

  // 定期テスト
  private setItems_regularTest() {
    this.items = getSchoolTermTestSemesterItems(this.isAll);
  }

  // 学校種別
  private setItems_schoolType() {
    this.items = getSchoolTypeItems(this.isAll);
  }

  // テスト学校種別
  private setItems_testSchoolType(isRegularTest: boolean) {
    const items = getTestSchoolTypeItems(this.isAll);
    if (isRegularTest) {
      this.items = items.filter((item) => item.id !== SchoolTypes.ElementarySchool);
    } else {
      this.items = items;
    }
  }

  // タグ
  private async setItems_tag() {
    if (!this.$store.state.itemSelect.tagList) {
      try {
        await this.$store.dispatch('itemSelect/fetchSubjectAndTag', this.schoolId);
      } catch (error) {
        return;
      }
    }
    this.items = this.$store.state.itemSelect.tagList;
  }

  // 講師
  private async setItems_teacher() {
    if (!this.$store.state.itemSelect.tutorList) {
      try {
        await this.$store.dispatch('itemSelect/fetchTutor', this.schoolId);
      } catch (error) {
        return;
      }
    }
    this.items = this.$store.state.itemSelect.tutorList;
  }

  // 学校
  private async setItems_school(schoolType: SchoolTypes) {
    if (!this.$store.state.itemSelect.ordinarySchoolList) {
      try {
        await this.$store.dispatch('itemSelect/fetchOrdinarySchool', this.schoolId);
      } catch (error) {
        return;
      }
    }
    const ordinarySchoolList = this.$store.state.itemSelect.ordinarySchoolList as OrdinarySchool[];
    if (schoolType === SchoolTypes.All) {
      this.items = ordinarySchoolList
        .map((ordinarySchool) => ({ id: ordinarySchool.id , name: ordinarySchool.name }));
    } else {
      this.items = ordinarySchoolList
        .filter((ordinarySchool) => ordinarySchool.schoolType === schoolType)
        .map((ordinarySchool) => ({ id: ordinarySchool.id , name: ordinarySchool.name }));
    }
  }

  // 学年
  private setItems_grade(schoolType: SchoolTypes) {
    switch (schoolType) {
      case SchoolTypes.ElementarySchool:
        this.items = getElementarySchoolGradeYearItems(this.isAll);
        break;
      case SchoolTypes.MiddleSchool:
        this.items = getMiddleSchoolGradeYearItems(this.isAll);
        break;
      case SchoolTypes.HighSchool:
        this.items = getHighSchoolGradeYearItems(this.isAll);
        break;
      default:
        this.items = getGradeYearItems(this.isAll, this.allDisplayedText);
        break;
    }
  }

  // 教科
  private async setItems_subject() {
    if (!this.$store.state.itemSelect.subjectList) {
      try {
        await this.$store.dispatch('itemSelect/fetchSubjectAndTag', this.schoolId);
      } catch (error) {
        return;
      }
    }
    this.items = this.$store.state.itemSelect.subjectList;
  }

  // その他テスト
  private async setItems_simulationTest(schoolType: SchoolTypes) {
    if (!this.$store.state.itemSelect.otherTestList) {
      try {
        await this.$store.dispatch('itemSelect/fetchOtherTest', this.schoolId);
      } catch (error) {
        return;
      }
    }
    const otherTestList = this.$store.state.itemSelect.otherTestList as OtherTest[];
    if (schoolType === SchoolTypes.All) {
      this.items = otherTestList
        .filter((otherTest, index) => {
          return index === otherTestList.findIndex((item) => item.testType === otherTest.testType);
        })
        .map((otherTest) => ({ id: otherTest.testType , name: otherTest.testType }));
    } else {
      this.items = otherTestList
        .filter((otherTest, index) => {
          return otherTest.schoolType === schoolType
            && index === otherTestList.findIndex((item) => item.testType === otherTest.testType);
        })
        .map((otherTest) => ({ id: otherTest.testType , name: otherTest.testTypeName }));
    }
  }

  // その他テスト年回
  private async setItems_simulationTestTimes(testType: string) {
    if (!testType || testType === '') {
      this.items = [];
    } else {
      if (!this.$store.state.itemSelect.otherTestList) {
        try {
          await this.$store.dispatch('itemSelect/fetchOtherTest', this.schoolId);
        } catch (error) {
          return;
        }
      }
      const otherTestList = this.$store.state.itemSelect.otherTestList as OtherTest[];
      this.items = otherTestList
        .filter((otherTest) => otherTest.testType === testType)
        .map((otherTest) => {
          const fiscalYear = `${otherTest.fiscalYear}年度`;
          const testTimes = `第${otherTest.testTimes}回`;
          return {
            id: otherTest.id,
            name: `${fiscalYear}　${testTimes}`
          };
        });
    }
  }

  // 登録済みカレンダー
  private async setItems_registCalenders() {
    if (this.$store.state.calendar.list.length <= 0) {
      try {
        await this.$store.dispatch('calendar/getListRequest');
      } catch (error) {
        return;
      }
    }

    const calenderList = this.$store.state.calendar.list as Calendar[];
    this.items = calenderList.map(
      (calendar) => {
        return {
          id: calendar.calendarId ,
          name: `${calendar.year}年${calendar.month}月`
        };
      });
  }

  private onChangeSelect() {
    this.$emit('update:selectedItem', this.selectedModel);
    this.$nextTick(() => {
      this.$emit('selectedItemChange', this.selectedModel);
    });
  }
}
